import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {docListResponseType} from '../../components/eca-doc-list/eca-doc-list.util';

interface IIndexingState {
  ecaDocumentViewerPopup: boolean;
  ecaDocZoom: number;
  fullScreenView: boolean;
  checkPanelSize: number;
  leftPanel: boolean;
  documentId: string;
  documentSummary: string;
  documentContent: string;
  documentLoading: boolean;
  highLightedWords: string[];
  allGridDocuments: docListResponseType[];
  createSummaryAllowed: boolean;
  truncatedBannerText: boolean;
  showHighLightedTab: boolean;
  extractedTextPath?: string;
  nativePath?: string;
  searchId?: string;
  strSearchFlag: boolean;
  updatedAllGridDocuments: docListResponseType[];
  availDocumentContent: boolean;
  activeDocsFlag?: string;
}

const initialState: IIndexingState = {
  ecaDocumentViewerPopup: false,
  ecaDocZoom: 100,
  fullScreenView: false,
  checkPanelSize: 0,
  leftPanel: false,
  documentId: '',
  documentSummary: '',
  documentContent: '',
  documentLoading: false,
  highLightedWords: [],
  allGridDocuments: [],
  createSummaryAllowed: false,
  truncatedBannerText: true,
  showHighLightedTab: false,
  extractedTextPath: '',
  nativePath: '',
  searchId: '',
  strSearchFlag: true,
  updatedAllGridDocuments: [],
  availDocumentContent: true,
  activeDocsFlag: '',
};

const ecaDocumentViewerSlice = createSlice({
  name: 'ecaDocumentViewer',
  initialState,
  reducers: {
    setEcaDocumentViewerModal(state, action: PayloadAction<boolean>) {
      state.ecaDocumentViewerPopup = action.payload;
    },
    setEcaDocZoom(state, action: PayloadAction<number>) {
      state.ecaDocZoom = action.payload;
    },
    setFullScreenView(state, action: PayloadAction<boolean>) {
      state.fullScreenView = action.payload;
    },
    setPanelSize(state, action: PayloadAction<number>) {
      state.checkPanelSize = action.payload;
    },
    setLeftPanel(state, action: PayloadAction<boolean>) {
      state.leftPanel = action.payload;
    },
    setDocumentId(state, action: PayloadAction<string>) {
      state.documentId = action.payload;
    },
    setAllGridDocuments(state, action: PayloadAction<docListResponseType[]>) {
      state.allGridDocuments = action.payload;
    },
    setDocumentContent(state, action: PayloadAction<string>) {
      state.documentContent = action.payload;
    },
    setDocumentLoading(state, action: PayloadAction<boolean>) {
      state.documentLoading = action.payload;
    },
    setHighLightedWords(state, action: PayloadAction<string[]>) {
      state.highLightedWords = action.payload;
    },
    setCreateSummaryAllowed(state, action: PayloadAction<boolean>) {
      state.createSummaryAllowed = action.payload;
    },
    setTruncatedBannerText(state, action: PayloadAction<boolean>) {
      state.truncatedBannerText = action.payload;
    },

    setShowHighLightedTab(state, action: PayloadAction<boolean>) {
      state.showHighLightedTab = action.payload;
    },

    setExtractedTextPath(state, action: PayloadAction<string>) {
      state.extractedTextPath = action.payload;
    },
    setNativePath(state, action: PayloadAction<string>) {
      state.nativePath = action.payload;
    },
    setSearchId(state, action: PayloadAction<string>) {
      state.searchId = action.payload;
    },
    setStrSearchFlag(state, action: PayloadAction<boolean>) {
      state.strSearchFlag = action.payload;
    },
    setUpdateAllGridDocuments(
      state,
      action: PayloadAction<docListResponseType[]>
    ) {
      state.updatedAllGridDocuments = action.payload;
    },
    setAvailableDocumentContent(state, action: PayloadAction<boolean>) {
      state.availDocumentContent = action.payload;
    },
    setActiveDocsFlag(state, action: PayloadAction<string>) {
      state.activeDocsFlag = action.payload;
    },
  },
});

export const {
  setEcaDocumentViewerModal,
  setEcaDocZoom,
  setFullScreenView,
  setPanelSize,
  setLeftPanel,
  setDocumentId,
  setAllGridDocuments,
  setDocumentContent,
  setDocumentLoading,
  setHighLightedWords,
  setCreateSummaryAllowed,
  setTruncatedBannerText,
  setShowHighLightedTab,
  setExtractedTextPath,
  setNativePath,
  setStrSearchFlag,
  setUpdateAllGridDocuments,
  setAvailableDocumentContent,
  setActiveDocsFlag,
  setSearchId,
} = ecaDocumentViewerSlice.actions;

export default ecaDocumentViewerSlice.reducer;
